import React from 'react';
import ShowMore from "../../../../../components/showMore";
import { convertDate } from '../../../../../util/dateTime';
import { getRateFromRateType } from '../../../../../util/getRateFromRateType';
import { getJobAddressString } from '../../../../../util/jobAddressString';
import "./JobDetails.scss";
import { currency_formatter } from '../../../../../util/currency_formatter';
import HoverPopup from '../../../../../components/hoverPopup';
import { iIcon } from '../../../../../assets/images';
import EngagementTypes from '../../../../../constants/engagementTypes';
import fractionalEngagementLevels from '../../../../../constants/FractionalEngagementLevels';

const JobDetails = ({
    roleGroup,
    role,
    projectId,
    postedOn,
    JobDescription,
    location,
    TimeZone,
    audienceData,
    RateType,
    rateMin,
    rateMax,
    rateCost,
    rateNegotiable,
    noOfPositions,
    estimatedTime,
    talent,
    showmore = false,
    data
}) => {

    const displayEngagementType = (engagementType) => {
        return Object.values(EngagementTypes).includes(engagementType)
    };

    return (
        <>
            <div className="OpenjobDetailsWrapper">
                <div className='font18Black boldFont mb-3'>Job Details</div>
                <div className="desktopView">
                    <div className="d-flex justify-content-between">
                        {
                            role?.length > 0 &&
                            <div className="flex-wrap-row">
                                <span className="font-weight-bold mr-2 noWrap">Role</span>
                                <div className="jobRoleName">
                                    {role?.map((data, index) => {
                                        return (
                                            <div 
                                                key={index} 
                                                className={(talent && !data.role) ? "d-none" : "pill mr-2"}
                                            >
                                                <span className="font14Black">
                                                    {data.role || "Other"}
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>
                                {
                                    displayEngagementType(data?.projectDetails?.engagementType) &&
                                        <>
                                            <div className="vertical-divider"/>
                                            <div className="font-weight-bold d-flex align-items-center flex-row noWrap">
                                                Engagement Type
                                                <HoverPopup
                                                    wrapperClass="ml-3"
                                                    trigger={
                                                        <div className="pill d-flex align-items-center">
                                                            <span className="font14Black">
                                                                {data?.projectDetails?.engagementType}
                                                            </span>
                                                        </div>
                                                    }
                                                >
                                                    <span className="font12Grey">
                                                        {data?.projectDetails?.engagementDescription}
                                                    </span>
                                                </HoverPopup>
                                            </div>
                                        </>
                                }

                                {
                                    data?.projectSpecification?.fractionalEngagementLevel &&
                                        <>
                                            <div className="vertical-divider"/>
                                            <div className="font-weight-bold d-flex align-items-center flex-row noWrap">
                                                Fractional Engagement Level
                                                <HoverPopup
                                                    wrapperClass="ml-3"
                                                    trigger={
                                                        <div className="pill d-flex align-items-center">
                                                            <span className="font14Black">
                                                                {data?.projectSpecification?.fractionalEngagementLevel}
                                                            </span>
                                                        </div>
                                                    }
                                                >
                                                    <span className="font12Grey">
                                                        {Object.values(fractionalEngagementLevels).find(l => l.name === data?.projectSpecification?.fractionalEngagementLevel)?.definition}
                                                    </span>
                                                </HoverPopup>
                                            </div>
                                        </>
                                }
                            </div>
                        }
                        <div className="ml-auto noWrap">
                            <span className="jobIdHeader">Job:</span> <span className="font12Black">{projectId}</span>{" | "}<span className="jobIdHeader">Posted On: </span><span className="font12Black">{convertDate(postedOn)}</span>
                        </div>
                    </div>
                    {JobDescription &&
                        <div className="mt-2">
                            <div className="font-weight-bold mr-3"></div>
                            <ShowMore
                                id="JobDescription"
                                lines={3}
                                textClass="font14Grey"
                                anchorClass="font14Blue"
                                text={JobDescription}
                            />
                        </div>
                    }
                    <hr></hr>
                    <div className="desktopView">
                        <div className='d-flex justify-content-between align-items-start'>

                        {
                            data?.projectBudget?.minSalary && data?.projectBudget?.maxSalary && 
                                <>
                                    <div className="font-weight-bold">Salary Range
                                        <div className="font14Grey">
                                            Min {currency_formatter(data?.projectBudget?.minSalary)} - Max {currency_formatter(data?.projectBudget?.maxSalary)}
                                        </div>
                                    </div>
                                </>
                        }

                        {RateType &&
                              <>
                                    <div>
                                        <div className="font-weight-bold">Rate Type</div>
                                        <div className="font14Grey">
                                            {RateType === "HOURLY" ? "Hourly" : RateType}
                                        </div>
                                    </div>
                                    <div>
                                        <div className="font-weight-bold">
                                            {`Estimated ${RateType ? RateType : ""} Rate`}
                                        </div>
                                        <div className="font14Grey">
                                            {getRateFromRateType(RateType, rateMin, rateMax, rateCost, rateNegotiable)}
                                        </div>
                                    </div>
                              </>
                        }
                            <div>
                                {
                                    estimatedTime ?
                                        <>
                                            <div className="font-weight-bold">Estimated Time Requirement</div>
                                            <div className="font14Grey">
                                                {estimatedTime}
                                            </div>
                                        </> :
                                        null
                                }
                            </div>
                        </div>
                    </div>
                    <hr></hr>
                    {roleGroup !== "C" &&
                        <>
                            <div className="d-flex">
                                {(audienceData?.audienceSize && audienceData?.isAudienceSizeFieldVisible) &&
                                    <div className="w-30 mr-5 mt-2">
                                        <div className="font-weight-bold ">Audience Size</div>
                                        <div className="font14Grey">{audienceData?.audienceSize}</div>
                                    </div>
                                }
                                {
                                    location &&
                                    <div className="w-30 mr-5 mt-2">
                                        <div className="font-weight-bold ">Location</div>
                                        <div className="font14Grey">
                                            {getJobAddressString(data?.projectDetails, true)}
                                        </div>
                                    </div>
                                }

                                {
                                    TimeZone &&
                                    <div className="w-30 mt-2">
                                        <div className="font-weight-bold ">Time Zone</div>
                                        <div className="font14Grey">{TimeZone}</div>
                                    </div>
                                }
                            </div>
                            {
                                audienceData?.description?.length > 0 &&
                                <>
                                    <div className="font-weight-bold mt-4"> Audience Description </div>
                                    <div className="font14Grey">{audienceData?.description}</div>
                                </>
                            }

                        </>
                    }
                </div>

                <div className="mobileView">
                    <div className="d-flex align-items-center">
                        <span className="font-weight-bold mr-3 mt-2"> Role</span>
                        {role?.map((data, index) => {
                            return (
                                <div key={index}>
                                    <div className="rolesandratesInactiveChipFreelancer mt-2">{data.role || "Other"}</div>
                                </div>
                            );
                        })}
                    </div>

                    {
                        displayEngagementType(data?.projectDetails?.engagementType) &&
                            <div className="mt-2">
                                <div className="font-weight-bold d-flex align-items-center flex-row">
                                    Engagement Type
                                    <div
                                        className="pill ml-3 d-flex align-items-center"
                                        title={data?.projectDetails?.engagementDescription}
                                    >
                                        <span className="font14Black">
                                            {data?.projectDetails?.engagementType}
                                        </span>
                                    </div>
                                </div>
                            </div>
                    }
                    {
                        data?.projectSpecification?.fractionalEngagementLevel &&
                            <div className="mt-2">
                                <div className="font-weight-bold d-flex align-items-center flex-row">
                                    Fractional Engagement Level
                                    <div
                                        className="pill ml-3 d-flex align-items-center"
                                        title={Object.values(fractionalEngagementLevels).find(l => l.name === data?.projectSpecification?.fractionalEngagementLevel)?.definition}
                                    >
                                        <span className="font14Black">
                                            {data?.projectSpecification?.fractionalEngagementLevel}
                                        </span>
                                    </div>
                                </div>
                            </div>
                    }
                    <div className="jobIdHeaderMobile">
                        <span>Job:{projectId}{" | "}Posted On: {convertDate(postedOn)}</span>
                    </div>
                    {JobDescription &&
                        <div className="mt-4">
                            <ShowMore
                                id="JobDescription"
                                lines={3}
                                textClass="font14Grey"
                                anchorClass="moreText"
                                text={JobDescription}
                            />
                        </div>
                    }
                    <div className="mobileView">
                        <hr></hr>
                        <div>
                            <div className="font-weight-bold mt-2">Rate Type</div>
                            <div className="font14Grey">
                                {RateType === "HOURLY" ? "Hourly" : RateType ? RateType : ""}
                            </div>
                        </div>
                        <div>
                            <div className="font-weight-bold mt-4">Estimated {RateType} Rate</div>
                            <div className="font14Grey">{getRateFromRateType(RateType, rateMin, rateMax, rateCost, rateNegotiable)}</div>
                        </div>

                        <div>
                            <div className="font-weight-bold mt-4">
                                Quantity Of Talent Needed
                            </div>
                            <div className="font14Grey">{noOfPositions}</div>
                        </div>
                        <hr></hr>
                    </div>
                    {roleGroup !== "C" &&
                        <>
                            <div>
                                {(audienceData?.isAudienceSizeFieldVisible) &&
                                    <div className="mt-4">
                                        <div className="font-weight-bold ">Audience Size</div>
                                        <div className="font14Grey">{audienceData?.audienceSize}</div>
                                    </div>
                                }
                                <div className="mt-4">
                                    <div className="font-weight-bold ">Location</div>
                                    <div className="font14Grey">
                                        {getJobAddressString(data?.projectDetails)}
                                    </div>
                                </div>

                                <div className="mt-4">
                                    <div className="font-weight-bold ">Timezone</div>
                                    <div className="font14Grey">{TimeZone}</div>
                                </div>

                            </div>
                            {
                                audienceData?.description?.length > 0 &&
                                <>
                                    <div className="font-weight-bold mt-4"> Audience Description </div>
                                    <div className="font14Grey">{audienceData?.description}</div>
                                </>
                            }
                        </>
                    }

                </div>
            </div>

        </>
    )
}

export default JobDetails;